import React from 'react';
import '../../styles/career/main.css';

const Main = () => {

    return (
        <div id='careerMain'>
            <div className="career-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Proceedings</h2>

                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
        
                                            <tr>
                                                <td>SWAYAM-CCSU course list (Even Sem, January-June 2025)</td>
                                                <td>
                                                    <a
                                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/SWAYAM-CCSU%20course%20list%20(Even%20Sem,%20January-June%202025).pdf"
                                                        className="btn btn-primary btn-download"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Nodal Officer appointment 17012025 (SWAYAM-CCSU)</td>
                                                <td>
                                                    <a
                                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/Nodal%20Officer%20appointment%2017012025%20(SWAYAM-CCSU).pdf"
                                                        className="btn btn-primary btn-download"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Proceedings of AC for SWAYAM Policy Framework CCSU 12022025</td>
                                                <td>
                                                    <a
                                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/Proceedings%20of%20AC%20for%20SWAYAM%20Policy%20Framework%20CCSU%2012022025.pdf"
                                                        className="btn btn-primary btn-download"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Swayam consolidated course list (odd sem, July-December 2025)</td>
                                                <td>
                                                    <a
                                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/Swayam%20consolidated%20course%20list%20(odd%20sem,%20July-December%202025).pdf"
                                                        className="btn btn-primary btn-download"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>UGC SWAYAM Steps for Credit Transfer for Univ & Colleges</td>
                                                <td>
                                                    <a
                                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/UGC%20SWAYAM%20Steps%20for%20Credit%20Transfer%20for%20Univ%20&%20Colleges.pdf"
                                                        className="btn btn-primary btn-download"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>UGC Framework for Universities</td>
                                                <td>
                                                    <a
                                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/UGC%20Framework%20for%20Universities.pdf"
                                                        className="btn btn-primary btn-download"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>UGC University Dashboard User Guide - v1.0 1</td>
                                                <td>
                                                    <a
                                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/UGC%20University%20Dashboard%20User%20Guide%20-%20v1.0%201.pdf"
                                                        className="btn btn-primary btn-download"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
